<template>
    <div class="page-sign-todo">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">活動</div>
            <div class="breadcrumb-item">活動詳情</div>
        </div>

        <div class="card-block">
            <Form inline class="pg-form-inline">
                <!-- <FormItem>
                    <Select size="small" placeholder="獎品1" v-model="form.store_id" clearable>
                        <Option :value="item.ReceivingID" v-for="(item, index) in pickAddress"
                                :key="item.ReceivingID">({{item.cainiao_match}}) {{item.ReceivingName}}
                        </Option>
                    </Select>
                </FormItem>
                <FormItem>
                    <Select size="small" placeholder="獎品2" v-model="form.paytype" ref="resetSelect" clearable>
                        <Option :value="1">APP端積分充值</Option>
                        <Option :value="2">PC端積分充值</Option>
                    </Select>
                </FormItem> -->
                <FormItem>
                    <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false"
                                placeholder="活動詳情-開始日期" value-format="yyyy-MM-dd hh:mm:ss" style="width: 100%;" :editable="false" v-model="form.start_time"></DatePicker>
                </FormItem>
                <FormItem>-</FormItem>
                <FormItem>
                    <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false"
                                placeholder="活動詳情-結束日期" value-format="yyyy-MM-dd hh:mm:ss" style="width: 100%;" :editable="false" v-model="form.end_time"></DatePicker>
                </FormItem>
            </Form>

            <Form inline class="pg-form-inline form-input-wrap">
                <FormItem>
                    <label class="input-label">手機號碼</label>
                    <Input size="small" clearable v-model="form.phone" @keyup.enter.native="handleSearch()" clearable></Input>
                </FormItem>
                <FormItem>
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style1" @click="handleSearch">搜索</div>
                        <!-- <div class="pg-btn style2" @click="handleExport">導出excel</div> -->
                    </div>
                </FormItem>
            </Form>
        </div>

        <div class="card-block pd-bt">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <Table ref="table"
                   size="small"
                   border
                   no-data-text="暫無數據"
                   :columns="table.column"
                   :data="table.data">
				  <template slot-scope="{ row, index }" slot="action">
				      <div class="pg-btn-wrap">
				          <div class="pg-btn style2" @click="handleModalSignShow(index)">查看詳情</div>
				      </div>
				  </template>
            </Table>

            <div class="pg-pagger">
                <Row>
                    <Col span="12" class="pagger-left">
                        <div class="pagger-total">總共 {{totalCount}} 條記錄</div>
                    </Col>
                    <Col span="12" class="pagger-right">
                        <!-- v-if="totalCount > curPageSize" -->
                        <div>
                            <div class="pagger-sizer">
                                <span>每頁</span>
                                <Select v-model="curPageSize" size="small" placeholder="數量"
                                        @on-change="handlePageSizeChange">
                                    <Option :value="10">10</Option>
                                    <Option :value="20">20</Option>
                                    <Option :value="30">30</Option>
                                    <Option :value="40">40</Option>
                                    <Option :value="50">50</Option>
                                </Select>
                            </div>

                            <div class="pagger-elevator">
                                <span>跳轉</span>
                                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                       @on-enter="handlePageEnter"/>
                            </div>

                            <Page size="small"
                                  :current="pageIndex"
                                  :page-size="curPageSize"
                                  :total="totalCount"
                                  @on-change="handlePageChange">
                            </Page>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>

        <Modal v-model="isShowModalSign"
               title="用戶日誌"
               width="650"
               :footer-hide="true"
               @on-cancel="handleModalSignClose">
            <div class="modal-cont">
               <div class="modal-sous">用戶電話: {{serial_number_single}}</div>
                    <Spin fix class="pg-sub-loading" v-if="isSubmitingLog">
                        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                        <div class="loading-text">Loading</div>
                    </Spin>
				   <Table ref="table"
                    size="small"
                    border
                    no-data-text="暫無數據"
                    :columns="table_log.column_log"
                    :data="table_log.data_log">
                   </Table>
            </div>
        </Modal>

    </div>
</template>

<script>
	import Store from '../../../assets/js/store.js'

	let isthis;
    export default {
        data()
        {
            return {
                pageIndex: 1,
                curPageSize: 10,
                totalCount: 1,
                pageInput: '',
                pickAddress: [],
                pickShelves: [],
                isSubmiting: false,
                isSubmitingLog: false,
                isShowModalSign: false,
                serial_number_single: '',

                form: {
                    uid:'',
                    paytype:'',
                    store_id: Store.fetch().store_id,
                    // phone:'',
                    serial_number: '',
                    created_at: ''
                },
                table: {
                    column: [
                        {
                            title: '最後抽獎日期',
                            key: 'created_at',
                            align: 'center',
                            minWidth: 150,
                            sortable: true
                        },
                        {
                            title: '手機號碼',
                            key: 'phone',
                            align: 'center',
                            minWidth: 150,
                            sortable: true
                        },
                        {
                            title: '獎品 (立減總數)',
                            key: 'discount',
                            align: 'center',
                            minWidth: 150,
                            sortable: true
                        },
                        {
                            title: '獎品 (集金幣總數)',
                            key: 'jpoint',
                            align: 'center',
                            minWidth: 150,
                            sortable: true
                        },
                        {
                            title: '參與次數',
                            key: 'frequency',
                            align: 'center',
                            minWidth: 150,
                            sortable: true
                        },
                        {
                            title: '用戶日誌',
                            slot: 'action',
                            align: 'center',
                            minWidth: 100
                        },
                    ],
                    data: []
                },
                table_log: {
				    column_log: [
				    	{
				    		title: '抽獎時間',
				    		align: 'center',
				    		key: 'lottery_time',
                            minWidth: 100
				    	},
                        {
                            title: '獎品',
                            align: 'center',
                            key: 'type',
                            minWidth: 50
                        },
				    ],
				    data_log: []
                },
            };
        },
		created() {
			this.getPickAddress();
		},
        mounted()
        {
			this.getList();
        },
        methods: {
            formatDate(datetime)
            {
                if (!datetime) return '';
                let dateTime = new Date(datetime);
                let year = dateTime.getFullYear();
                let month = dateTime.getMonth() + 1;
                let date = dateTime.getDate();
                let hour = dateTime.getHours();
                let minute = dateTime.getMinutes();
                let second = dateTime.getSeconds();
                let milliseconds = dateTime.getMilliseconds();
                return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(milliseconds)}`;
            },
            formatNum(num)
            {
                return num < 10 ? '0' + num : num;
            },
            getPickAddress() //提貨櫃點
            {
                this.$Rq.requestAuth({
                    url: this.$Api.pickAddress,
                    method: 'get',
                    data: {
                        company_id: 1,
                    }
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        this.pickAddress = res.data.data;
						if (res.data.data.length <= 1) {
							this.form.arrive = res.data.data[0].ReceivingID;
						}
                    }
                });
            },
            handleStoreChange(index) {
                this.$refs.resetSelect.clearSingleSelect();
            },
            getList(){
                let form = this.form;
                this.isSubmiting = true;
                this.$Rq.requestAuth({
                    url: this.$Api.eventLogList,
                    method: 'get',
                    data: {
                        lottery_id: form.lottery_id,
                        phone: form.phone,
                        frequency: form.frequency,
                        start_time: this.formatDate(form.start_time),
                        end_time: this.formatDate(form.end_time),
                        offset: (this.pageIndex - 1) * this.curPageSize,
                        limit: this.curPageSize
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;
                    if (res.code == 0)
                    {
                        let tempArr = [];
                        let resData = res.data.data;

                        for (let i = 0; i < resData.length; i++)
                        {
                            tempArr.push({
                                id: resData[i].id, 
                                lottery_id: resData[i].lottery_id,
                                phone: resData[i].phone == null ? '- - -' : resData[i].phone,
                                jpoint: resData[i].jpoint == null ? 0 : resData[i].jpoint,
                                discount: resData[i].discount == null ? '- - -' : resData[i].discount,
                                frequency: resData[i].frequency == null ? '- - -' : resData[i].frequency,
                                created_at: resData[i].created_at,
                            });
                        }
                        this.totalCount = res.data.count;
                        this.table.data = tempArr;
                    } else {
                        this.showTipInfo(res.msg);
                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
                });
            },

            handleModalSignShow(index){
                this.isShowModalSign = true;
                this.isSubmitingLog = true;
                let tableData = this.table.data;
                let user_phone = tableData[index].phone;
                this.serial_number_single = tableData[index].phone;
                this.$Rq.requestAuth({
                    url: this.$Api.LotteryLogList,
                    method: 'get',
                    data: {
                        user_phone: user_phone
                    }
                }).then((res) =>
                {
                    this.isSubmitingLog = false;
                    if (res.code == 0)
                    {
                        let tempArr_log = [];
                        let resData = res.data.data;

                        for (let i = 0; i < resData.length; i++)
                        {           
                            if(resData[i].type == 1){
                              resData[i].type = '';
                              resData[i].number = '立減' + resData[i].number;
                            }
                            else if(resData[i].type == 2){
                              resData[i].type = '集金幣';
                              resData[i].number = '+' + resData[i].number;
                            }
                            else if(resData[i].type == 3){
                              resData[i].type = '其他';
                            }
                            else{
                              resData[i].type = '- - -';
                            }

                            tempArr_log.push({
                                lottery_time: resData[i].lottery_time,
                                type: resData[i].number + resData[i].type,
                            });
                        }

                        this.table_log.data_log = tempArr_log;
                    }
                    
                }).catch((err) =>
                {
                    this.isSubmitingLog = false;
                });
            },

            handleModalSignClose(){
                this.isShowModalSign = false;
            },

            handleSearch(){
                this.pageIndex = 1;
                this.getList();
            },

			handleExport(){
				let token = localStorage.getItem('jyb_token');
				let form = this.form;
				let params = {
                    // arrive: form.arrive,
                    paytype: form.paytype,
                    start_time: this.formatDate(form.start_time),
                    end_time: this.formatDate(form.end_time),
					// serial_number: form.serial_number,
                    // phone: form.phone,
                    // uid: form.uid
				};
				let formatParams = this.$Utils.formateObjToParamStr(params);				
				// if(form.start_time == ''){
				// 	this.$Utils.showTipInfo("請選擇起始時間");
				// }
				// else if(form.end_time == ''){
				// 	this.$Utils.showTipInfo("請選擇结束時間");
				// }
				// else{
					window.open(`${this.$Api.payOrderflow_export}?${formatParams}`, '_blank');
                    // this.exportLink = `${this.$Api.deliverFexport}?${formatParams}`;
				// }
			},

            handlePageSizeChange(value){
                this.pageIndex = 1;
                this.getList();
            },

            handlePageInput(){
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.floor(this.totalCount / this.curPageSize);
                if (value > pageCount)
                {
                    value = pageCount;
                }
                this.pageInput = value;
            },

            handlePageEnter(){
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0)
                {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
				this.getList();
            },

            handlePageChange(value){
                this.pageIndex = value;
                this.getList();
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import 'eventLog.scss';
</style>